import { render } from "./ReportSyncGeofenceSummaryKm.vue?vue&type=template&id=fd887014"
import script from "./ReportSyncGeofenceSummaryKm.vue?vue&type=script&lang=js"
export * from "./ReportSyncGeofenceSummaryKm.vue?vue&type=script&lang=js"

import "./ReportSyncGeofenceSummaryKm.vue?vue&type=style&index=0&id=fd887014&lang=css"
script.render = render

export default script